import { useEffect } from 'react';

const DEFAULT_TITLE = 'Cantir';

export function PageHead({ title, description }: { title: string; description?: string }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    document.title = fullTitle;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);

  useEffect(() => {
    if (!description) return;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
    return () => {
      meta?.setAttribute('content', '');
    };
  }, [description]);

  return null;
}
